/* eslint-disable camelcase */
/* eslint-disable max-len */
export const video_interview = {
  'micro-test': 'Խոսափողի ստուգում',
  'indicator-reacts': 'Կլոր ցուցիչը արձագանքում է արտաքին ձայներին։ Լրացրեք այն ամբողջությամբ',
  'if-indicator-donot-reacts': 'Եթե ցուցիչը չի արձագանքում, կամ դիտարկիչը լրացուցիչ թույլտվություն է հայցում, սեղմեք «Թույլատրել հասանելիությունը» կոճակը',
  'interview-finished': 'Հարցազրույցն ավարտվել է։ Շնորհակալությո՛ւն',
  'answer-successfuly-sent': 'Պատասխանները հաջողությամբ ուղարկվել են',
  'prepering-to-recording': 'Դուք ունեք {seconds} վայրկյան պատրաստվելու համար։ Տեսաձայնագրումը կսկսվի «Սկսել տեսաձայնագրումը» կոճակը սեղմելուց հետո։',
  'current-step': 'Հարց {currentStep}՝ {maxStep}-ից',
  'question-text': 'Հարցի տեքստը՝',
  'show-question': 'Ցույց տալ հարցը',
  'test-record': 'Փորձնական տեսաձայնագրություն',
  'make-test-record': 'Կատարեք փորձնական տեսաձայնագրություն․ ասեք ինչ-որ բան՝ նայելով տեսախցիկին։ Դուք կտեսնեք, թե ինչ տեսք կունենան Ձեր պատասխանները',
  'start-recording': 'Սկսել տեսաձայնագրումը',
  'stop-recording': 'Սկսել տեսաձայնագրումը',
  're-record': 'Սկսել տեսաձայնագրումը',
  'turn-on-the-camera': 'Միացրե՛ք տեսախցիկը',
  'selection-stages': 'Ընտրության փուլերը',
  questionnaire: 'Հարցաթերթիկ',
  'video-interview': 'Հարցաթերթիկ',
};
